/* eslint-disable react/prop-types */
import React from 'react';
import { Provider } from 'react-redux';

import { NikeDotcomApp } from '@nike/web-shell-next/dist/components/NikeDotcomApp';
import { configureStore } from '@nike/ciclp-redux-app';
import { createWrapper } from 'next-redux-wrapper';
import {
  sanitizeForSerialization,
  deserializeState,
} from '../helpers/serializeState';

export const wrapper = createWrapper(() => configureStore(), {
  debug: false,
  deserializeState,
  serializeState: state => sanitizeForSerialization(state),
});

const setNavConfig = navConfig => config => ({
  ...config,
  appInfo: {
    ...config.appInfo,
    environment: 'production',
    name: navConfig?.pageDetail,
    version: process.env.NES_COMMIT_SHA ?? 'development',
    viewChannel: navConfig?.analyticsPageType,
    viewName: navConfig?.globalNavPageName,
  },
});

function App(appProps) {
  const { store, props } = wrapper.useWrappedStore(appProps);
  return (
    <Provider store={store}>
      <NikeDotcomApp
        {...props}
        beforeNavMount={setNavConfig(props.pageProps?.navConfig)}
      />
    </Provider>
  );
}

export default App;
